import React, {useEffect, useState, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import PageApp from '../../../Page';
import { CloseOutlined, CheckOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Switch, Space, message, Modal, Typography, DatePicker } from 'antd';
import {insert, update, dropParameter, getParameters, getById} from '../../../../apis/FuncionApi';
import Highlighter from "react-highlight-words";
import Parameters from './Parameters'
import dayjs from 'dayjs';
import { HomeOutlined, UnorderedListOutlined, MoonFilled, SunFilled} from '@ant-design/icons';
import { defFunction, declareFuncionInicio, declareFuncionFin, codeInit} from '@app/constants/definition_python';
import Editor from '@monaco-editor/react';

const { Title } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;
const routes = [  
    {
        href: '',
        title: <>
        <HomeOutlined />
        <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
        <>
            <UnorderedListOutlined />
            <span>Catálogos</span>
        </>
        ),
    },
    {
        href: '../funciones',
        title: (
        <>
            <UnorderedListOutlined />
            <span>Funciones</span>
        </>
        ),
    },
    {
        href: '',
        title: (
            <>
            <UnorderedListOutlined />
            <span>Función</span>
            </>
        ),
    }
];

const App = () => {
    let navigate = useNavigate();
    const { id } = useParams();
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id == -1? null: id);
    const [modified, setModified] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [dataParameters, setDataParameters] = useState([]);
    const [openNewParameters, setOpenNewParameters] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [initialValues, setInitialValues] = useState(null);
    const [themeEditor, setThemeEditor] = useState('light');
    const searchInput = useRef(null);
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        let funcion = editorRef.current.getValue();
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields,
                funcion: funcion
            }
            const response = await update(payload);
            if(response.ok){
                message.success('Se actualizó correctamente el concepto!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields,
                funcion: funcion
            }
            const response = await insert(payload);
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el periodo!');
            }
        }

        setModified(true);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                if(ID > 0){
                    await refreshData();
                }else{
                    setInitialValues({
                        nombre: null,
                        descripcion: null,
                        funcion: codeInit,
                        ayuda: null,
                        tipo_dato: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async ()=> {
        await refreshFuncion()
    }

    const refreshFuncion = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let item = response.payload;
            if(item.fecha){
                item.fecha = dayjs(item.fecha, 'YYYY-MM-DD');
            }
            setInitialValues(item);
        }
    }

    const onClose = (reload)=>{
        return navigate("../funciones");
    }

    const editorRef = useRef(null);

    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
    }

    function getName(){
        const fields = form.getFieldsValue()
        let newName = fields.descripcion.replaceAll(" ", "_");
        return newName;
    }

    const onChangeName = async () => {
        let newName = getName();
        let currentCode = editorRef.current.getValue();
        let newDefFunction = 'def '+newName+'():';
        let currentDefinition =  (currentCode.split(declareFuncionInicio)[1] || "").split(declareFuncionFin)[0];
        if(currentDefinition == defFunction){
            currentCode = currentCode.replace(currentDefinition, `${declareFuncionInicio}\n${newDefFunction}\n${declareFuncionFin}`) 
        }else{
            currentCode = currentCode.replace(currentDefinition, `\n${newDefFunction}\n`)
        }
        editorRef.current.getModel().setValue(currentCode);
        // setCode(currentCode);
    }

    const onChangeTheme = async (value) => {
        setThemeEditor(value?'light':'vs-dark');
    }

    return (
        <PageApp routes={routes}>
            <div style={{paddingBottom: 20}}>
                <div style={{float: 'left'}}>
                    <span title=""></span>
                </div>
                <span class="" style={{float:'right'}}>
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>
                </span>
            </div>
            <Divider/>  
            {
                initialValues && 
                <Form 
                    layout="vertical" 
                    form={form} 
                    requiredMark 
                    autoComplete="off"
                    initialValues={initialValues} 
                    onFinish={handleOk}>
                    <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Row gutter={16}>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="nombre"
                                        label="Nombre"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega un nombre',
                                        },
                                        ]}
                                    >
                                        <Input placeholder="Por favor agrega un nombre" />
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="descripcion"
                                        label="Descripción"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega una descripción',
                                        },
                                        ]}
                                    >
                                        <Input placeholder="Por favor agrega una descripción" />
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="ayuda"
                                        label="Ayuda"
                                        rules={[
                                        {
                                            required: false,
                                            message: 'Por favor agrega una ayuda',
                                        },
                                        ]}
                                    >
                                        <TextArea placeholder="Por favor agrega una descripción" rows={4} maxLength={6}/>
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="fecha"
                                        label="Fecha"
                                    >
                                        <DatePicker placeholder="DD/MM/YYYY"  style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="activo"
                                        label="Activo"
                                        >
                                        <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Row gutter={16}>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}} style={{marginBottom: 20, marginLeft: 20}}>
                                    Color del editor
                                    <Switch defaultChecked checkedChildren={<SunFilled />} unCheckedChildren={<MoonFilled />} onChange={onChangeTheme} style={{marginLeft: 20}}/>
                                </Col>
                            </Row>
                            <Editor
                                height="90vh"
                                defaultLanguage="python"
                                defaultValue={initialValues.funcion}
                                theme={themeEditor}
                                options={{
                                    inlineSuggest: true,
                                    fontSize: "16px",
                                    formatOnType: true,
                                    autoClosingBrackets: true,
                                    minimap: { scale: 10 }
                                }}
                                onMount={handleEditorDidMount}
                                />
                        </Col>
                    </Row>
                </Form>
            }
        </PageApp>
    );
};
export default App;
